import React, { useState } from "react";
import Footer from "./Footer";
import Nav from "./Nav";
import StoryCard from "./StoryCard";
import customerStoriesData from "../data/customerStories";
import { LatestEpisodeData, usersDataModal } from "../atoms/atom";
import { useRecoilState } from "recoil";
import allEpisodesData from "../data/allEpisodes";

const Podcast = () => {
  const [latestEpisodesData, setLatestEpisodesData] =
    useRecoilState(LatestEpisodeData);
  // console.log("data", data);

  return (
    <div>
      <Nav active="customerStories" />
      <div className="bg-[#f4f8f9] pb-16">
        <div className=" max-w-[600px] mx-auto px-5 pt-8 pb-20">
          <h1 className="md:text-[48px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#323a41] mt-3">
            The Videocraft Show Archive
          </h1>
        </div>

        <div className="max-w-[1320px] mx-auto flex flex-wrap items-center justify-around xl:justify-between">
          {allEpisodesData.map((item, index) => {
            return (
              <StoryCard
                from="podcast"
                key={index}
                heading={item.heading}
                description={item.description1}
                img={item.img}
                click={() => {
                  setLatestEpisodesData(item);
                }}
              />
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Podcast;
